import React, { memo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@/app/routing/index';
import LogoutIcon from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import useLogoutIntentStore from '@/common/stores/logout-intent';

const LogoutLink = ({ className }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();
  const requestLogout = useLogoutIntentStore((state) => state.requestLogout);

  const logout = () => {
    const nextPath = pathname.includes(routes.adminPanel.index)
      ? routes.adminLogin
      : routes.login;

    requestLogout(nextPath);
    history.replace(nextPath);
  };

  return (
    <Button
      onClick={logout}
      variant="text"
      color="secondary"
      size="medium"
      sx={{ justifyContent: 'flex-start' }}
      startIcon={<LogoutIcon sx={{ fontSize: 20 }} />}
      fullWidth
    >
      {t('Log out')}
    </Button>
  );
};

export default memo(LogoutLink);
